/**
 * @generated SignedSource<<fc80fd2926d2c2c7ac9665247e563031>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PageType = "SearchRefundAmt";
export type checkLookPageMutation$variables = {
  pageType: PageType;
  refundId: string;
};
export type checkLookPageMutation$data = {
  readonly checkLookPage: {
    readonly result: boolean;
  };
};
export type checkLookPageMutation = {
  response: checkLookPageMutation$data;
  variables: checkLookPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "pageType",
        "variableName": "pageType"
      },
      {
        "kind": "Variable",
        "name": "refundId",
        "variableName": "refundId"
      }
    ],
    "concreteType": "CheckLookPageOutput",
    "kind": "LinkedField",
    "name": "checkLookPage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "checkLookPageMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "checkLookPageMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1f75a402c5909c9b9b5f3c39b0c12f47",
    "id": null,
    "metadata": {},
    "name": "checkLookPageMutation",
    "operationKind": "mutation",
    "text": "mutation checkLookPageMutation(\n  $refundId: String!\n  $pageType: PageType!\n) {\n  checkLookPage(refundId: $refundId, pageType: $pageType) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "c511d9b0717d63cda2a2bb3780a425fd";

export default node;
